import { getAssociatedTicketIds } from 'conversations-thread-data/thread-details/public/operators';
import TicketPrimaryActions from './TicketPrimaryActions';
import ThreadPrimaryActions from 'conversations-thread-view/thread-toolbar/components/ThreadPrimaryActions';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadHeaderPrimaryActions = props => {
  const associatedTicketIds = getAssociatedTicketIds(props.threadDetails);
  const ticketExists = !!(associatedTicketIds && associatedTicketIds.size);
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  if (!shouldLimitTicketFunctionality && (props.ticket || ticketExists)) {
    return /*#__PURE__*/_jsx(TicketPrimaryActions, Object.assign({
      ticketExists: ticketExists
    }, props));
  } else {
    return /*#__PURE__*/_jsx(ThreadPrimaryActions, Object.assign({}, props));
  }
};
ThreadHeaderPrimaryActions.displayName = 'ThreadHeaderPrimaryActions';
export default ThreadHeaderPrimaryActions;